<div class="popup">
  <div class="popup__content">
    <ng-content></ng-content>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/popup/popup.component.html